/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

/**
 *
 * @export
 * @interface WithSignupMin
 */
export interface WithSignupMinOptional {
  /**
   *
   * @type {number}
   * @memberof WithSignupMin
   */
  signupMin?: number;
}

export interface WithSignupMin extends WithSignupMinOptional {
  /**
   *
   * @type {number}
   * @memberof WithSignupMin
   */
  signupMin?: number;
}

export interface WithSignupMinTrackedI {
  /**
   *
   * @type {number}
   * @memberof WithSignupMin
   */
  signupMin?: number;
  signupMinIsSet: boolean;
}

transformDatesMap.set("WithSignupMin", function (model: WithSignupMin) {});

export type WithSignupMinMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  signupMin: PropertyMeta<MetaTypeBase<number>>;
}>;

export var WithSignupMinMeta: WithSignupMinMetaI = {} as WithSignupMinMetaI;
WithSignupMinMeta = typeMeta("WithSignupMin", {
  signupMin: propertyMeta(
    "signupMin",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
});

const metaI = WithSignupMinMeta;

registerMeta(() => {});

export class WithSignupMinTracked implements WithSignupMinTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  signupMin__I?: number = undefined;
  signupMinIsSet: boolean = false;
  set signupMin(v: undefined | number) {
    if (v !== undefined) {
      this.signupMin__I = v;
      this.signupMinIsSet = true;
    } else {
      this.signupMin__I = v || undefined;
      this.signupMinIsSet = false;
    }
    this.changeTracker = true;
  }
  get signupMin() {
    return this.signupMin__I;
  }
  constructor(config?: WithSignupMinOptional, options?: AssignOptions) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {}
  assignFrom(
    config: WithSignupMinOptional,
    options?: AssignOptions,
  ): WithSignupMinTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.signupMin && this.signupMinApplyFilter(optionsRequired.filter)) {
      this.signupMin = config.signupMin;
      if (optionsRequired.unassign) this.signupMinIsSet = false;
      else this.signupMinIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): WithSignupMinTrackedI {
    const cloned = {} as WithSignupMinTrackedI;
    if (
      this.signupMinIsSetDeep() &&
      this.signupMinApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.signupMinIsSet = true;
      cloned.signupMin = this.signupMin;
    } else {
      //cloned.signupMinIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): WithSignupMinTrackedI {
    if (!this.signupMinApplyFilter(filter)) this.signupMinIsSet = false;

    return this;
  }
  signupMinApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      WithSignupMinMeta.signupMin,
      WithSignupMinMeta,
      this.signupMin,
      this,
    );
  }
  signupMinIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.signupMinIsSet && this.signupMinApplyFilter(filter)) return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.signupMinIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
